import { useState } from "react";
import { toast } from "sonner";
import { Shuffle } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export const ReplaceVenueButton = ({ kit, it, reload }) => {
  const [open, setOpen] = useState(false);
  const busy = ["queued", "generating", "verifying", "fact_checking", "fixing"].includes(kit.status) || kit.filling;
  const go = async () => {
    try {
      await http.post(`/kits/${kit.id}/verification/${it.id}/replace`);
      toast.success(`Finding a web-verified replacement for ${it.name}`);
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <button data-testid={`verify-replace-${it.id}`} disabled={busy} onClick={() => setOpen(true)} title="Swap this venue for a web-verified alternative"
        className="inline-flex items-center gap-1 rounded-sm border border-stone-300 px-3 py-1.5 text-xs text-stone-600 hover:text-stone-900 hover:bg-stone-100 disabled:opacity-40">
        <Shuffle size={12} /> Replace
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid={`verify-replace-dialog-${it.id}`} className="bg-white text-[#2B2A26]">
          <AlertDialogHeader>
            <AlertDialogTitle>Replace {it.name}?</AlertDialogTitle>
            <AlertDialogDescription>
              The AI will web-search for a currently operating venue of the same type in {kit.destination}, check its official website, and swap it in — including any mentions elsewhere in the guide. Any "I've been here" mark on this venue won't carry over. Takes a few minutes and uses a small amount of AI credit.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`verify-replace-cancel-${it.id}`} className="bg-white">Keep it</AlertDialogCancel>
            <AlertDialogAction data-testid={`verify-replace-confirm-${it.id}`} onClick={go} className="bg-[#2B2A26] text-white hover:bg-black">Replace</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
